window.addEventListener("DOMContentLoaded", function () {
  // Determine language based on the URL path (e.g., /de/..., /ja/...)
  const path = window.location.pathname;
  let currentLang = "en"; // Default
  if (path.startsWith("/de/") || path === "/de") {
    currentLang = "de";
  } else if (path.startsWith("/ja/") || path === "/ja") {
    currentLang = "ja";
  } else if (
    path.startsWith("/zh/") ||
    path === "/zh" ||
    path.startsWith("/zh-TW/") ||
    path === "/zh-TW"
  ) {
    currentLang = "zh-TW";
  } else if (path.startsWith("/es/") || path === "/es") {
    currentLang = "es";
  }

  if (currentLang && currentLang !== "en") {
    const translations = {
      de: {
        policyWording:
          "Diese Website speichert Cookies auf Ihrem Computer. Diese Cookies werden verwendet, um Informationen darüber zu sammeln, wie Sie mit unserer Website interagieren, und um uns an Sie zu erinnern. Wir verwenden diese Informationen, um Ihr Surferlebnis zu verbessern und anzupassen, sowie für Analysen und Kennzahlen zu unseren Besuchern auf dieser Website und in anderen Medien. Weitere Informationen zu den von uns verwendeten Cookies finden Sie in unserer <a href='https://premioinc.com/pages/privacy-policy/' rel='nofollow' target='_blank'>Datenschutzrichtlinie</a>.",
        disclaimer:
          "Wir erfassen Ihre Informationen nicht, wenn Sie unsere Website besuchen. Um Ihren Präferenzen jedoch gerecht zu werden, müssen wir nur einen winzigen Cookie verwenden, damit Sie nicht erneut gebeten werden, diese Auswahl zu treffen.",
        accept: "Akzeptieren",
        decline: "Ablehnen",
      },
      ja: {
        policyWording:
          "このウェブサイトはお使いのコンピューターにCookieを保存します。これらのCookieは、お客様が当社のウェブサイトをどのように利用しているかに関する情報を収集し、お客様を記憶するために使用されます。当社は、ブラウジング体験の向上とカスタマイズ、およびこのウェブサイトや他のメディアにおける訪問者に関する分析と指標のためにこの情報を使用します。当社が使用するCookieの詳細については、<a href='https://premioinc.com/pages/privacy-policy/' rel='nofollow' target='_blank'>プライバシーポリシー</a>をご覧ください。",
        disclaimer:
          "当社のサイトを訪問しても、情報は追跡されません。ただし、お客様の好みを尊重するため、この選択を再度求められないように、1つの小さなCookieのみを使用する必要があります。",
        accept: "同意する",
        decline: "拒否する",
      },
      "zh-TW": {
        policyWording:
          "本網站會在您的電腦上儲存 Cookie。這些 Cookie 用於收集您與我們網站互動的資訊，並用於記住您。我們使用這些資訊來改善和自訂您的瀏覽體驗，以及進行分析和統計，以了解本網站及其他媒體的訪客情況。更多有關我們使用的 Cookie 的資訊，請參閱我們的 <a href='https://premioinc.com/pages/privacy-policy/' rel='nofollow' target='_blank'>隱私政策</a>。",
        disclaimer:
          "即使您訪問我們的網站，我們也不會收集您的資訊。然而，為了尊重您的偏好，我們只需使用一個小型 Cookie，以避免再次要求您做出選擇。",
        accept: "接受",
        decline: "拒絕",
      },
      es: {
        policyWording:
          "Este sitio web almacena cookies en su computadora. Estas cookies se utilizan para recopilar información sobre cómo interactúa con nuestro sitio web y para recordarle. Usamos esta información para mejorar y personalizar su experiencia de navegación, así como para análisis y métricas sobre nuestros visitantes en este sitio web y otros medios. Para obtener más información sobre las cookies que usamos, consulte nuestra <a href='https://premioinc.com/pages/privacy-policy/' rel='nofollow' target='_blank'>Política de Privacidad</a>.",
        disclaimer:
          "No recopilamos su información cuando visita nuestro sitio web. Sin embargo, para respetar sus preferencias, solo necesitamos usar una pequeña cookie para que no se le vuelva a pedir que haga esta elección.",
        accept: "Aceptar",
        decline: "Rechazar",
      },
    };

    const langData = translations[currentLang];

    if (langData) {
      // Translation Logic
      const applyTranslation = () => {
        const policyContainer = document.querySelector(
          "#hs-eu-policy-wording p span",
        );
        const disclaimer = document.getElementById("hs-eu-cookie-disclaimer");
        const acceptBtn = document.getElementById("hs-eu-confirmation-button");
        const declineBtn = document.getElementById("hs-eu-decline-button");

        let translated = false;

        if (
          policyContainer &&
          policyContainer.innerHTML !== langData.policyWording
        ) {
          policyContainer.innerHTML = langData.policyWording;
          translated = true;
        }
        if (disclaimer && disclaimer.innerHTML !== langData.disclaimer) {
          disclaimer.innerHTML = langData.disclaimer;
          translated = true;
        }
        if (acceptBtn && acceptBtn.innerText !== langData.accept) {
          acceptBtn.innerText = langData.accept;
          translated = true;
        }
        if (declineBtn && declineBtn.innerText !== langData.decline) {
          declineBtn.innerText = langData.decline;
          translated = true;
        }

        return translated;
      };

      // Try applying translations dynamically as HubSpot loads the modal
      const observer = new MutationObserver(function (mutations, me) {
        if (applyTranslation()) {
          // Disconnect observer once the translation successfully applies to stop wasting resources
          me.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Run immediately in case it's already generated via sync load.
      if (applyTranslation()) {
        observer.disconnect();
      }
    }
  }
});
